function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isFunction } from 'vega-util';
import { isBinned, isBinning } from '../../../bin';
import { X, X2, Y2, getMainRangeChannel } from '../../../channel';
import { binRequiresRange, getBandPosition, isDatumDef, isFieldDef, isFieldOrDatumDef, isTypedFieldDef, isValueDef, vgField } from '../../../channeldef';
import { dateTimeToExpr, isDateTime } from '../../../datetime';
import { isExprRef } from '../../../expr';
import * as log from '../../../log';
import { hasDiscreteDomain } from '../../../scale';
import { TEMPORAL } from '../../../type';
import { contains, stringify } from '../../../util';
import { isSignalRef } from '../../../vega.schema';
import { signalOrValueRef } from '../../common';
import { getConditionalValueRefForIncludingInvalidValue } from './invalid';
export function midPointRefWithPositionInvalidTest(params) {
  var channel = params.channel,
    channelDef = params.channelDef,
    markDef = params.markDef,
    scale = params.scale,
    scaleName = params.scaleName,
    config = params.config;
  var scaleChannel = getMainRangeChannel(channel);
  var mainRef = midPoint(params);
  var valueRefForIncludingInvalid = getConditionalValueRefForIncludingInvalidValue({
    scaleChannel: scaleChannel,
    channelDef: channelDef,
    scale: scale,
    scaleName: scaleName,
    markDef: markDef,
    config: config
  });
  return valueRefForIncludingInvalid !== undefined ? [valueRefForIncludingInvalid, mainRef] : mainRef;
}
export function datumDefToExpr(datumDef) {
  var datum = datumDef.datum;
  if (isDateTime(datum)) {
    return dateTimeToExpr(datum);
  }
  return "".concat(stringify(datum));
}
export function valueRefForFieldOrDatumDef(fieldDef, scaleName, opt, encode) {
  var ref = {};
  if (scaleName) {
    ref.scale = scaleName;
  }
  if (isDatumDef(fieldDef)) {
    var datum = fieldDef.datum;
    if (isDateTime(datum)) {
      ref.signal = dateTimeToExpr(datum);
    } else if (isSignalRef(datum)) {
      ref.signal = datum.signal;
    } else if (isExprRef(datum)) {
      ref.signal = datum.expr;
    } else {
      ref.value = datum;
    }
  } else {
    ref.field = vgField(fieldDef, opt);
  }
  if (encode) {
    var offset = encode.offset,
      band = encode.band;
    if (offset) {
      ref.offset = offset;
    }
    if (band) {
      ref.band = band;
    }
  }
  return ref;
}
/**
 * Signal that returns the middle of a bin from start and end field. Should only be used with x and y.
 */
export function interpolatedSignalRef(_ref) {
  var scaleName = _ref.scaleName,
    fieldOrDatumDef = _ref.fieldOrDatumDef,
    fieldOrDatumDef2 = _ref.fieldOrDatumDef2,
    offset = _ref.offset,
    startSuffix = _ref.startSuffix,
    _ref$endSuffix = _ref.endSuffix,
    endSuffix = _ref$endSuffix === void 0 ? 'end' : _ref$endSuffix,
    _ref$bandPosition = _ref.bandPosition,
    bandPosition = _ref$bandPosition === void 0 ? 0.5 : _ref$bandPosition;
  var expr = !isSignalRef(bandPosition) && 0 < bandPosition && bandPosition < 1 ? 'datum' : undefined;
  var start = vgField(fieldOrDatumDef, {
    expr: expr,
    suffix: startSuffix
  });
  var end = fieldOrDatumDef2 !== undefined ? vgField(fieldOrDatumDef2, {
    expr: expr
  }) : vgField(fieldOrDatumDef, {
    suffix: endSuffix,
    expr: expr
  });
  var ref = {};
  if (bandPosition === 0 || bandPosition === 1) {
    ref.scale = scaleName;
    var field = bandPosition === 0 ? start : end;
    ref.field = field;
  } else {
    var datum = isSignalRef(bandPosition) ? "(1-".concat(bandPosition.signal, ") * ").concat(start, " + ").concat(bandPosition.signal, " * ").concat(end) : "".concat(1 - bandPosition, " * ").concat(start, " + ").concat(bandPosition, " * ").concat(end);
    ref.signal = "scale(\"".concat(scaleName, "\", ").concat(datum, ")");
  }
  if (offset) {
    ref.offset = offset;
  }
  return ref;
}
export function binSizeExpr(_ref2) {
  var scaleName = _ref2.scaleName,
    fieldDef = _ref2.fieldDef;
  var start = vgField(fieldDef, {
    expr: 'datum'
  });
  var end = vgField(fieldDef, {
    expr: 'datum',
    suffix: 'end'
  });
  return "abs(scale(\"".concat(scaleName, "\", ").concat(end, ") - scale(\"").concat(scaleName, "\", ").concat(start, "))");
}
/**
 * @returns {VgValueRef} Value Ref for xc / yc or mid point for other channels.
 */
export function midPoint(_ref3) {
  var channel = _ref3.channel,
    channelDef = _ref3.channelDef,
    channel2Def = _ref3.channel2Def,
    markDef = _ref3.markDef,
    config = _ref3.config,
    scaleName = _ref3.scaleName,
    scale = _ref3.scale,
    stack = _ref3.stack,
    offset = _ref3.offset,
    defaultRef = _ref3.defaultRef,
    bandPosition = _ref3.bandPosition;
  // TODO: datum support
  if (channelDef) {
    /* istanbul ignore else */
    if (isFieldOrDatumDef(channelDef)) {
      var _ref4;
      var scaleType = scale === null || scale === void 0 ? void 0 : scale.get('type');
      if (isTypedFieldDef(channelDef)) {
        bandPosition !== null && bandPosition !== void 0 ? bandPosition : bandPosition = getBandPosition({
          fieldDef: channelDef,
          fieldDef2: channel2Def,
          markDef: markDef,
          config: config
        });
        var bin = channelDef.bin,
          timeUnit = channelDef.timeUnit,
          type = channelDef.type;
        if (isBinning(bin) || bandPosition && timeUnit && type === TEMPORAL) {
          // Use middle only for x an y to place marks in the center between start and end of the bin range.
          // We do not use the mid point for other channels (e.g. size) so that properties of legends and marks match.
          if (stack !== null && stack !== void 0 && stack.impute) {
            // For stack, we computed bin_mid so we can impute.
            return valueRefForFieldOrDatumDef(channelDef, scaleName, {
              binSuffix: 'mid'
            }, {
              offset: offset
            });
          }
          if (bandPosition && !hasDiscreteDomain(scaleType)) {
            // if band = 0, no need to call interpolation
            // For non-stack, we can just calculate bin mid on the fly using signal.
            return interpolatedSignalRef({
              scaleName: scaleName,
              fieldOrDatumDef: channelDef,
              bandPosition: bandPosition,
              offset: offset
            });
          }
          return valueRefForFieldOrDatumDef(channelDef, scaleName, binRequiresRange(channelDef, channel) ? {
            binSuffix: 'range'
          } : {}, {
            offset: offset
          });
        } else if (isBinned(bin)) {
          if (isFieldDef(channel2Def)) {
            return interpolatedSignalRef({
              scaleName: scaleName,
              fieldOrDatumDef: channelDef,
              fieldOrDatumDef2: channel2Def,
              bandPosition: bandPosition,
              offset: offset
            });
          } else {
            var channel2 = channel === X ? X2 : Y2;
            log.warn(log.message.channelRequiredForBinned(channel2));
          }
        }
      }
      return valueRefForFieldOrDatumDef(channelDef, scaleName, hasDiscreteDomain(scaleType) ? {
        binSuffix: 'range'
      } : {},
      // no need for bin suffix if there is no scale
      {
        offset: offset,
        // For band, to get mid point, need to offset by half of the band
        band: scaleType === 'band' ? (_ref4 = bandPosition !== null && bandPosition !== void 0 ? bandPosition : channelDef.bandPosition) !== null && _ref4 !== void 0 ? _ref4 : 0.5 : undefined
      });
    } else if (isValueDef(channelDef)) {
      var value = channelDef.value;
      var offsetMixins = offset ? {
        offset: offset
      } : {};
      return _objectSpread(_objectSpread({}, widthHeightValueOrSignalRef(channel, value)), offsetMixins);
    }
    // If channelDef is neither field def or value def, it's a condition-only def.
    // In such case, we will use default ref.
  }
  if (isFunction(defaultRef)) {
    defaultRef = defaultRef();
  }
  if (defaultRef) {
    // for non-position, ref could be undefined.
    return _objectSpread(_objectSpread({}, defaultRef), offset ? {
      offset: offset
    } : {});
  }
  return defaultRef;
}
/**
 * Convert special "width" and "height" values in Vega-Lite into Vega value ref.
 */
export function widthHeightValueOrSignalRef(channel, value) {
  if (contains(['x', 'x2'], channel) && value === 'width') {
    return {
      field: {
        group: 'width'
      }
    };
  } else if (contains(['y', 'y2'], channel) && value === 'height') {
    return {
      field: {
        group: 'height'
      }
    };
  }
  return signalOrValueRef(value);
}